import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Username = styled("span")`
    color: ${({theme}) => theme.uxfabric.text.primary};
    text-transform: ${({theme}) => theme.uxfabric.global.body1.textTransform};
    font-size: ${({theme}) => theme.uxfabric.global.body1.fontSize};
    font-family: ${({theme}) => theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-weight: ${({theme}) => theme.uxfabric.global.body1.fontWeight};
`
